import React from "react";
import { OfferDocument } from "../../assets/icons";

interface LoanOfferErrorProps {
  errorMessage?: string;
  description?: string;
}

const LoanOfferError: React.FC<LoanOfferErrorProps> = ({
  description = "Your loan offer has been revoked and can't be accessed at this time. If there's anything else you'd like to do or need further assistance, feel free to reach out to us at",
  errorMessage = "We're sorry, This offer is no longer valid!",
}) => {
  return (
    <div className="cx-flex cx-flex-col cx-items-center cx-h-[298px] cx-gap-8 cx-shrink-0">
      <div className="cx-w-[152px] cx-h-[152px] cx-flex-shrink-0 cx-rounded-full cx-bg-[#EDF5FF] cx-flex cx-items-center cx-justify-center">
        <OfferDocument className="cx-text-xs" />
      </div>
      <div className="cx-text-text-primary cx-font-bold cx-text-2xl cx-text-center">
        {errorMessage}
      </div>
      <div className="cx-w-[660px] cx-text-text-secondary cx-text-center cx-text-base cx-font-normal cx-leading-[22px]">
        {description}{" "}
        <a href="mailto:support@crediblex.io" className="cx-text-text-brand">
          support@crediblex.io
        </a>
      </div>
    </div>
  );
};

export default LoanOfferError;
